module.exports = __webpack_public_path__ + "static/media/network-security.cc890c78.png";